//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"Name",1,0]],[[["objTag"],"SetBaseObject",{},1,0],[["objTag","dRadius","dRatio","bMasterFlag"],"AddPulley",{R_:{pulleyData:''}},4,0],[["objTag"],"DeletePulley",{},1,0],[["numParameterData"],"GetPulleyBeltData",{R_:{parameterData:""}},0,0],[["parameterData"],"SetPulleyBeltData",{},1,0]],[]];
SPLM.Mechatronics.PulleyBeltBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.PulleyBeltBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.PulleyBeltBuilder.PulleyBeltData = class{
    constructor(bMasterFlag,jointObjName,dRatio,dRadius,faceObject,jointObject){
        this.bMasterFlag=bMasterFlag;this.jointObjName=jointObjName;this.dRatio=dRatio;this.dRadius=dRadius;this.faceObject=faceObject;this.jointObject=jointObject;}
    get Bmasterflag(){return this.bMasterFlag}
    set Bmasterflag(val){this.bMasterFlag = val}
    get Jointobjname(){return this.jointObjName}
    set Jointobjname(val){this.jointObjName = val}
    get Dratio(){return this.dRatio}
    set Dratio(val){this.dRatio = val}
    get Dradius(){return this.dRadius}
    set Dradius(val){this.dRadius = val}
    get Faceobject(){return this.faceObject}
    set Faceobject(val){this.faceObject = val}
    get Jointobject(){return this.jointObject}
    set Jointobject(val){this.jointObject = val}
};

export default SPLM;